import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft as BackIcon } from '@material-ui/icons';
import NavLink from '../../controls/NavLink';
import {
    makeStyles,
    Grid,
    Typography,
    Paper,
    TableContainer,
    Box,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { MTableBodyRow } from 'material-table';
import { useHistory } from 'react-router-dom';
import { getFullName } from '../../util';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    entityName: {
        fontSize: 36,
        color: '#333333',
        letterSpacing: ' -0.56px',
        lineHeight: '44px',
    },
    disableText: {
        color: '#666666',
    },
    backButton: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#484848',
        lineHeight: '24px',
        marginLeft: -7,
    },
    contentSpacer: {
        marginTop: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(10),
        },
    },
}));

const LicenseeResults = ({ location }) => {
    const classes = useStyles();
    const [resultList, setResultList] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);
    const history = useHistory();
    const [entities] = useState(location.state.resultList);

    const selectResult = (result) => {
        const person = result[0];
       history.push(`/licensees/${person.id}`, { person });
    };

    useEffect(() => {
        (async function () {
            try {
                setLoading(true);
                setResultList(entities.map((result) => { return { ...result } }));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            } finally {
                setLoading(false);
            }
        })();
    }, [entities]);

    return (
        <>
            <Grid container item xs={12} spacing={4} justifyContent="center" alignItems="center" direction="column">
                <div className={classes.contentSpacer} />
                <Grid item xs={12} sm={8} container spacing={1} direction="column">
                    <Grid item>
                        <NavLink to="/" variant="subtitle1">
                            <span className={classes.backButton}>
                                <BackIcon />
                                Find Licensee
                            </span>
                        </NavLink>
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Box pt={3} pb={1}>
                                    <Typography className={classes.entityName}>Search Results</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TableContainer component={Paper}>
                            <MaterialTable
                                tableRef={tableRef}
                                options={{
                                    toolbar: false,
                                    paging: false,
                                    draggable: false,
                                    header: false,
                                    actionsColumnIndex: 1,
                                    selectionProps: () => ({
                                        color: 'primary',
                                    }),
                                }}
                                columns={[
                                    {
                                        title: 'Person ID',
                                        field: 'personId',
                                        render: function customRender(rowData) {
                                            return (
                                                <Typography className={classes.disableText}>
                                                    {rowData.id}
                                                </Typography>
                                            );
                                        },
                                    },
                                    {
                                        title: 'Name',
                                        field: 'name',
                                        render: function customRender(rowData) {
                                            return (
                                                <Typography className={classes.disableText}>
                                                    {!rowData.type.isOrganization && getFullName(rowData.name)}
                                                    {rowData.type.isOrganization && rowData.name}
                                                </Typography>
                                            );
                                        },
                                    },
                                ]}
                                actions={[
                                    {
                                        tooltip: 'Select result',
                                    },
                                ]}
                                noDataMessage="No Search Results"
                                data={resultList}
                                onSelectionChange={selectResult}
                                components={{
                                    Container: function ContainerComponent({ children }) {
                                        return <div>{children}</div>;
                                    },
                                    Row: function RowComponent(props) {
                                        return (
                                            <MTableBodyRow
                                                {...{
                                                    ...props,
                                                    options: {
                                                        ...props.options,
                                                        selection: true,
                                                    },
                                                }}
                                            />
                                        );
                                    },
                                    Action: function ActionComponent() {
                                        return selectResult;
                                    },
                                }}
                                isLoading={loading}
                            />
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default LicenseeResults;
